import React from 'react';
import PropTypes from 'prop-types';

const ListenButton = ({ id, onClick, disabled, dataCallState }) => {
  const className = disabled ? 'call-button listen-now--disabled' : 'call-button listen-now';

  const handleClick = (event) => {
    event.preventDefault();

    onClick();
  };

  return (
    <div>
      <a
        id={id}
        href="#"
        onClick={handleClick}
        data-call-state={dataCallState}
      >
        <div className={className}>
          <span>Call Now</span>
        </div>
      </a>
    </div>
  );
};

ListenButton.defaultProps = {
  disabled: false,
  id: null,
  dataCallState: null,
};

ListenButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  dataCallState: PropTypes.string,
};

export default ListenButton;
